import React, { useEffect } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/MicroBundle/paginateStyle';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import { makeStyles } from '@material-ui/core';
import { isMobileDevice } from 'utils/helpers';
import { PLANS_PER_PAGE } from '../constants';

export const Paginate = ({
	maxPages,
	lastplanIndex,
	setfirstPlanIndex,
	setLastPlanIndex,
	maxItems,
	firstPlanIndex,
}: any) => {
	//@ts-ignore
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	useEffect(() => {
		renderDots();
	}, [lastplanIndex]);

	const renderDots = () => {
		const dotsArray = [];
		for (let i = 1; i <= maxPages; i++) {
			dotsArray.push(
				<div className={i == Math.ceil(lastplanIndex / PLANS_PER_PAGE) ? classes.selectedDot : classes.dot}></div>
			);
		}
		return dotsArray;
	};
	const Dots = () => {
		return <div className={classes.dotsWrapper}>{renderDots()}</div>;
	};

	const Arrows = () => {
		return (
			<div className={classes.arrowWrapper}>
				<ArrowRightAltIcon
					onClick={() => {
						if (firstPlanIndex == 0) return;
						setfirstPlanIndex((prev: number) => prev - 1);
						setLastPlanIndex(lastplanIndex - 1);
					}}
					className={firstPlanIndex > 0 ? classes.enableArrow : ''}
					style={{ transform: 'rotate(180deg)' }}
				/>
				<ArrowRightAltIcon
					className={lastplanIndex < maxItems ? classes.enableArrow : ''}
					onClick={() => {
						if (lastplanIndex >= maxItems) return;
						setfirstPlanIndex((prev: number) => {
							return prev + 1;
						});
						setLastPlanIndex(lastplanIndex + 1);
					}}
				/>
			</div>
		);
	};
	return (
		<>
			{!isMobileDevice() && <Dots />}
			<Arrows />
		</>
	);
};
